import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';

import { TReconnectConfig } from '../../types/reconnection-config';
import { DashworksServiceComponent } from './DashworksServiceComponent';

export const DashworksReconnectionConfig: TReconnectConfig = {
  statusesForDisplaying: [
    AppConnectionStatuses.UPDATE_AVAILABLE,
    AppConnectionStatuses.DISCONNECTED,
  ],
  serviceComponent: DashworksServiceComponent,
};
